import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useColorScheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { noop } from 'ramda-extension';

import Xmark from '@gef-ui/material-icons/Xmark';

import DragDrop from 'components/atoms/CustomSVGIcon/DragDrop';

const CardSticker = ({ text, id, onRemove = noop, showHeaderRightIcon = true }) => {
	const { mode: appTheme } = useColorScheme();

	const handleOnClose = useCallback(() => {
		onRemove(id);
	}, [onRemove, id]);

	return (
		<Card
			sx={{
				borderRadius: '5px',
				boxShadow: '0 0 13px 0 rgba(0,0,0,.24)',
				height: '60px',
				backgroundColor: appTheme === 'light' ? 'common.white' : 'background.300',
			}}
		>
			<CardContent sx={{ p: 1 }}>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Stack
						direction="row"
						spacing={1}
						sx={{
							alignItems: 'center',
						}}
					>
						<Box sx={{ color: 'info.shades.50p', fontSize: '15px', pt: 0.5 }}>
							<DragDrop />
						</Box>
						<Typography
							sx={{
								fontWeight: 'medium',
								fontSize: 13,
							}}
						>
							{text}
						</Typography>
					</Stack>
					{showHeaderRightIcon && (
						<IconButton onClick={handleOnClose}>
							<Xmark sx={{ color: 'primary.main' }} />
						</IconButton>
					)}
				</Stack>
			</CardContent>
		</Card>
	);
};

CardSticker.propTypes = {
	id: PropTypes.number,
	onRemove: PropTypes.func,
	showHeaderRightIcon: PropTypes.string,
	text: PropTypes.string,
};

export default CardSticker;
